import { RouteConfig } from 'vue-router'
import Compare from "@/views/Compare/Compare.vue";


const routes: Array<RouteConfig> = [
  {
    path: '/bcatalog/compare',
    name: 'compare-desktop-page',
    component: Compare
  }
]

export default routes;
